export function ChangeAppPassword(value){

    let errors = {};
    if(!value.password){
        errors.password = 'Password is required';
    }
    if(!value.password_confirmation){
        errors.password_confirmation = 'Password confirmation is required';
    }
    
    return errors;


}